<template>
    <section class="contract-module">
        <!-- Loading -->
        <loading />

        <div class="icon-text-wrapper mb-tablet-only">
            <p @click="showSidebarMenu()" role="button" class="turnback">
                Menu
            </p>
        </div>

        <h1 id="header" class="heading-4 title">Editar contrato</h1>

        <!-- 
            <div data-reference="name" class="input-wrapper">
                <label for="name" class="subtitle body-1 strong-600">Nome</label>
                <input
                    type="text"
                    @focusin="inputValidationCase('name')"
                    @focusout="inputValidationCase('name')"
                    v-model="name"
                    class="form-control body-1"
                    id="name"
                    placeholder="Nome"
                    maxlength="150"
                />
            </div>
        -->
        <p class="strong-600 subtitle">Contrato</p>

        <!-- Text Editor -->
        <div class="contract-wrapper">
            <QuillEditor
                ref="quilltexteditor"
                toolbar="essential"
                theme="snow"
                placeholder="Add Contract"
                @focusin="getEditorDescriptionData()"
                @focusout="getEditorDescriptionData()"
            />
        </div>

        <div class="btns-wrapper">
            <button
                @click="sendData(editorData)"
                type="submit"
                class="btn btn-primary btnsubmit button-body"
                :disabled="disabled"
            >
                Guardar alterações
            </button>

            <!-- 
                <button
                    @click="turnBack()"
                    type="button"
                    class="btn btndelete button-body"
                >
                    Eliminar contrato
                </button>             

                <button
                    @click="turnBack()"
                    type="button"
                    class="btn btncancel button-body"
                >
                    Cancelar
                </button>
            -->
        </div>

        <!-- Back To Top -->
        <back-to-top idhref="header" />

        <!-- Response Messages -->
        <div
            @click="closeMessageBox($event)"
            class="responsebasemessage"
            ref="responsebasemessage"
        >
            <list-message />
        </div>
    </section>
</template>
<script>
import fetchData from "./../../../fetchData.js";
import Loading from "./../../elements/LoadingElement.vue";
import ListMessage from "./../../elements/ListMessageElement.vue";
import BackToTop from "./../../elements/BackToTopElement.vue";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import defaultWebsite from "./../../../defaultWebsiteScript.js";
import responseMessage from "./../../../responseMessage.js";
import CardElement from "./../../elements/CardElement.vue";

//Set Use Strict
("use strict");

export default {
    name: "ContractAdmin",
    props: {
        csrftolken: {
            type: String,
            required: true,
        },
        contract: {
            type: String,
            required: true,
        },
        routineurl: {
            type: String,
            required: true,
        },
        createurl: {
            type: String,
            required: true,
        },
        updateurl: {
            type: String,
            required: true,
        },
    },
    data: () => {
        return {
            editorData: "",
            disabled: true,
            activeclass: "d-flex",
            contractData: {},
            routine: {},
            responseTimeOut: 5000,
        };
    },
    created() {
        //Parse Values
        this.contractData = JSON.parse(this.contract);

        //Set Value
        this.editorData = this.contractData.contract_data;
    },
    mounted() {
        //Set Quill Content editor
        this.setEditorDescriptiondata(this.editorData);

        window.addEventListener("DOMContentLoaded", function () {
            defaultWebsite.primaryContentConditional(window.screen.width);
        });
    },
    methods: {
        closeMessageBox(element) {
            responseMessage.closeBox(element.target);
        },
        turnBack() {
            defaultWebsite.turnBack();
        },
        showSidebarMenu() {
            defaultWebsite.showSidebarMenu();
        },
        getEditorDescriptionData() {
            //Other ways to get content
            //console.log(this.$refs.quilltexteditor.editor.innerHTML);
            //console.log(this.$refs.quilltexteditor.getContents());

            //Check variable
            this.editorData = "";

            //Check content from Quill Editor Text
            if (this.$refs.quilltexteditor.getHTML() !== "<p><br></p>") {
                //Enabled Button
                this.disabled = false;

                //Get Content from Editor
                this.editorData = this.$refs.quilltexteditor.getHTML();
            } else {
                //Disabled Button
                this.disabled = true;
            }

            return this.editorData;
        },
        setEditorDescriptiondata(description) {
            //Check content
            if (this.editorData) {
                //Set Content
                this.$refs.quilltexteditor.setHTML(description);
            }
        },

        sendData(data) {
            //Disabled Button
            this.disabled = true;

            //Check Data
            if (data === "" || data === "<p><br></p>") {
                alert("É obrigatório adicionar o contrato!");

                return;
            }

            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            //Set Routine
            this.routine =
                this.contractData.length === 0
                    ? {
                          method: "POST",
                          formdata: {
                              contract: data.trim(),
                          },
                          url: this.createurl,
                      }
                    : {
                          method: "PUT",
                          formdata: {
                              contract: data.trim(),
                              id: this.contractData.contract_id,
                          },
                          url: this.updateurl,
                      };

            //Send Data
            let response = fetchData.structureTosendData(
                this.routineurl,
                this.routine.formdata,
                this.csrftolken,
                this.routine.method
            );

            //Check Promisse
            response
                .then((value) => {
                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Render Response Message
                    responseMessage.renderResponseMessages(
                        this.$refs.responsebasemessage,
                        value.classname,
                        value.message,
                        this.activeclass,
                        this.responseTimeOut
                    );

                    //Enabled Button
                    this.disabled = false;

                    //Check Success
                    if (
                        Object.is(value.classname, "success") &&
                        this.contractData.length === 0
                    ) {
                        window.location.reload();
                    }
                })
                .catch((error) => {
                    //Enabled Button
                    this.disabled = false;

                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    throw new Error(error);
                });
        },
    },
    computed: {
        computedEditorData() {
            return this.editorData;
        },
        computedRoutine() {
            return this.routine;
        },
    },
    watch: {
        computedEditorData() {},
        computedRoutine() {},
    },
    components: {
        loading: Loading,
        QuillEditor,
        listMessage: ListMessage,
        backToTop: BackToTop,
        cardElement: CardElement,
    },
};
</script>
